import React from "react";

export const CasinoCardIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    data-ds-icon="Casino"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      fill="currentColor"
      d="m2.14 4.63 7.25-3.38c.63-.3 1.34-.23 1.89.11-.09.14-.18.28-.26.43L4.81 15.1 1.17 7.29c-.47-1-.03-2.19.97-2.66Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m21.86 4.63-7.25-3.38c-1-.47-2.19-.03-2.66.97l-6.76 14.5c-.47 1-.03 2.19.97 2.66l7.25 3.38c1 .47 2.19.03 2.66-.97l6.76-14.5c.47-1 .03-2.19-.97-2.66Zm-9.54 11-.85-4.81 2.3-4.4.85 4.81-.85 4.4h-1.45Z"
      clipRule="evenodd"
    />
  </svg>
);

export const TelegramPaperPlaneIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.7 3.24c.33-.14.68.17.58.52l-4.7 16.87c-.1.37-.55.5-.84.25l-4.82-4.2-2.74 2.65c-.33.32-.89.09-.89-.37v-3.88l9.61-8.66c.22-.2-.05-.54-.3-.38L6.05 13.18 1.9 11.87c-.4-.13-.44-.67-.07-.85L21.7 3.24Z"
    />
  </svg>
);
